export default ({ request }) => ({
  saveAndCancelCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/saveAndCancel',
      method: 'post',
      data
    })
  },
  addCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/add',
      method: 'post',
      data
    })
  },
  delCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/del',
      method: 'post',
      data
    })
  },
  deListCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/delList',
      method: 'post',
      data
    })
  },
  samListCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/samList',
      method: 'post',
      data
    })
  },
  resListCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCollect/resList',
      method: 'post',
      data
    })
  }
})
